const GENERATED_SAMPLE_STORAGE_PREFIX = "style-guide-generated-samples";

export function getGeneratedSampleStorageKey(projectId?: string | null) {
  return `${GENERATED_SAMPLE_STORAGE_PREFIX}:${projectId || "global"}`;
}

export function readGeneratedSampleStorage(projectId?: string | null): Record<string, string> {
  if (typeof window === "undefined" || !window.localStorage) return {};

  try {
    const storedValue = window.localStorage.getItem(getGeneratedSampleStorageKey(projectId));
    if (!storedValue) return {};
    const parsedValue = JSON.parse(storedValue);
    if (!parsedValue || typeof parsedValue !== "object" || Array.isArray(parsedValue)) return {};

    return Object.fromEntries(
      Object.entries(parsedValue).filter((entry): entry is [string, string] => typeof entry[1] === "string"),
    );
  } catch {
    return {};
  }
}

export function writeGeneratedSampleStorage(projectId: string | undefined | null, samplesByStyleKey: Record<string, string>) {
  if (typeof window === "undefined" || !window.localStorage) return;

  const storageKey = getGeneratedSampleStorageKey(projectId);
  try {
    if (Object.keys(samplesByStyleKey).length === 0) {
      window.localStorage.removeItem(storageKey);
      return;
    }
    window.localStorage.setItem(storageKey, JSON.stringify(samplesByStyleKey));
  } catch {
    // Local storage can be disabled or full; generated previews are optional UI cache.
  }
}
